const MAX_BADGE_NUMBER = 99;

export function formatBadgeNumber(count: number, maxBadgeNumber = MAX_BADGE_NUMBER) {
  return count > maxBadgeNumber ? `${maxBadgeNumber}+` : count;
}
